import { ReportAPI } from 'api'
import { mapResponse } from 'utils/api'

import { IQueryConfig } from '../query/types'

import { SalesSeatToolUsageQuery } from './types'

const toSalesSeatToolUsageQuery = (
  queryConfig: IQueryConfig
): SalesSeatToolUsageQuery => ({
  startDate: queryConfig.startDate,
  endDate: queryConfig.endDate,
})

export const fetchSalesSeatUsageCSV = (
  queryConfig: IQueryConfig,
  csvType: string
): Promise<string> => {
  const query = toSalesSeatToolUsageQuery(queryConfig)
  return ReportAPI.post<string>(
    `/sales_seat_data/${
      csvType === 'toolUsage' ? 'tool_usage' : 'accounts_influenced'
    }`,
    query
  ).then(mapResponse)
}
